import React, { useEffect, useState, lazy, Suspense, useRef } from "react";
import { API_BASE_URL, Assets_URL } from "../../../Apicongfig";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { FaExpand } from "react-icons/fa"; // Import the FaExpand icon
import { PiFilePdfLight } from "react-icons/pi";
import { IoCopyOutline, IoVideocamOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import {
  convertCount2ToSeconds,
  convertTimeTakenToSeconds,
  formatPauseTime,
  formatStepDate,
  getTimeUnitDisplay,
} from "../../../Utils/MeetingFunctions";
import { HiUserCircle } from "react-icons/hi2";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlinePhotoSizeSelectActual,
} from "react-icons/md";
import { toast } from "react-toastify";
import { RiFileExcel2Line } from "react-icons/ri";
import Spreadsheet from "react-spreadsheet";
import { read, utils } from "xlsx";
import DOMPurify from "dompurify";

const ActiveReportStepCard = ({
  setIsModalOpen1,
  data,
  startTime,
  users,
  fromMeeting,
  meeting,
  runStep,
  reRunStep,
  isRun,
  isReOpen,
}) => {
  const [t] = useTranslation("global");
  const [excelData, setExcelData] = useState(null);
  const [inProgressStep, setInProgressStep] = useState(null);

  const handleStepCardButtonClick = (item) => {
    setIsModalOpen1(true); // Update the modal open state
  };

  const convertTo24HourFormat = (time, date, type, timezone) => {
    if (!time || !date || !type) {
      return false;
    }

    const meetingTimezone = timezone || "Europe/Paris";
    const userTimezone = moment.tz.guess();

    // Convert meeting time from its original timezone to the user's timezone
    const convertedTime = moment
      .tz(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss A", meetingTimezone)
      .tz(userTimezone);

    // Assuming time is in 'hh:mm:ss A' format (12-hour format with AM/PM)
    // const timeMoment = moment(time, "hh:mm:ss A");
    // return timeMoment.isValid() ? timeMoment.format("HH:mm:ss") : "";
    // Assuming time is in 'hh:mm:ss A' format (12-hour format with AM/PM)
    const timeMoment = moment(convertedTime, "hh:mm:ss A");

    // Check if the time is valid
    if (!timeMoment.isValid()) return "";

    // If the meeting type is 'Quiz', include seconds in the format
    const format = type === "seconds" ? "HH[h]mm[m]ss" : "HH[h]mm";

    // Return the time in the appropriate format
    return timeMoment.format(format);
  };

  const localizeTimeTakenActive = (timeTaken) => {
    if (!timeTaken) return "";

    // Retrieve localized time units
    const timeUnits = t("time_unit", { returnObjects: true });

    // Split the timeTaken string by " - " to separate time components
    const timeParts = timeTaken.split(" - ");

    // Initialize variables for each time component
    let days = null;
    let hours = null;
    let minutes = null;
    let seconds = null;

    // Iterate over each part and assign it to the corresponding variable
    timeParts.forEach((part) => {
      if (part.includes("day")) {
        days = part;
      } else if (part.includes("hour")) {
        hours = part;
      } else if (part.includes("min")) {
        minutes = part;
      } else if (part.includes("sec")) {
        seconds = part;
      }
    });

    // Check if days are present
    const hasDays = Boolean(days);

    // Determine what to show based on the presence of days
    let result = "";
    if (hasDays) {
      // Show days and hours if days are present
      result = [days, hours].filter(Boolean).join(" - ");
    } else if (hours) {
      // Show only hours and minutes if hours and minutes are present
      result = [hours, minutes].filter(Boolean).join(" - ");
    } else if (minutes) {
      // Show minutes only if no days or hours are present
      // result = minutes;
      result = [minutes, seconds].filter(Boolean).join(" - ");
    } else {
      result = seconds;
    }

    // Return empty string if result is undefined or empty
    if (!result) return "";

    // Localize and return the result
    return result
      .split(" ")
      .map((part) => (isNaN(part) ? timeUnits[part] || part : part))
      .join(" ");
  };

  const getYoutubeEmbedUrl = (url) => {
    if (!url) {
      return false;
    }
    if (url.includes("youtube.com/watch")) {
      const videoUrl = new URL(url);
      const videoId = videoUrl.searchParams.get("v");

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
      // Handle the shortened YouTube URL (youtu.be)
    }
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1];
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    return false; // Return false if it's not a valid YouTube URL
  };
  const [dropdownVisible, setDropdownVisible] = useState(
    Array(data?.length).fill(true)
  );
  const dropdownRefs = useRef([]);

  useEffect(() => {
    data?.forEach((item, index) => {
      const el = dropdownRefs.current[index];
      if (el) {
        if (dropdownVisible[index]) {
          el.style.display = "block";
          requestAnimationFrame(() => {
            el.classList.add("show");
          });
        } else {
          el.classList.remove("show");
          el.addEventListener(
            "transitionend",
            () => {
              el.style.display = "none";
            },
            { once: true }
          );
        }
      }
    });
  }, [dropdownVisible, data]);

  useEffect(() => {
    const currentInProgressStep = meeting?.steps.find(
      (item) => item.step_status === "in_progress"
    );
    setInProgressStep(currentInProgressStep || null);
  }, [meeting?.steps]);

  // Fetch Excel data when inProgressStep changes
  useEffect(() => {
    const fetchExcel = async () => {
      if (inProgressStep?.editor_type === "Excel" && inProgressStep?.file) {
        try {
          const fileResponse = await axios.get(
            `${Assets_URL}/${inProgressStep.file}`,
            {
              responseType: "arraybuffer",
            }
          );

          const fileData = fileResponse.data;
          const workbook = read(fileData, { type: "buffer" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonSheetData = utils.sheet_to_json(worksheet, { header: 1 });

          const formattedData = jsonSheetData.map((row, rowIndex) =>
            row.map((cell) => ({
              value: cell,
              readOnly: rowIndex === 0,
            }))
          );

          setExcelData(formattedData);
        } catch (error) {
          console.error("Error fetching Excel file:", error);
        }
      }
    };

    if (inProgressStep) {
      fetchExcel();
    }
  }, [inProgressStep]);

  const sanitizeContent = (content) => {
    if (!content) return null;

    const sanitizedContent = DOMPurify.sanitize(content, {
      ADD_TAGS: [
        "table",
        "tr",
        "td",
        "th",
        "tbody",
        "thead",
        "tfoot",
        "caption",
        "iframe",
      ],
      ADD_ATTR: [
        "allow",
        "allowfullscreen",
        "frameborder",
        "scrolling",
        "src",
        "title",
        "style",
      ],
    });

    // Create a temporary div to hold the sanitized HTML and parse it
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = sanitizedContent;

    // Find all iframe tags within the content
    const iframes = tempDiv.querySelectorAll("iframe");

    // Replace each iframe tag with a link while preserving its surrounding structure
    iframes.forEach((iframe) => {
      const iframeSrc = iframe.getAttribute("src");

      if (iframeSrc) {
        const linkElement = document.createElement("a");
        linkElement.href = iframeSrc;
        linkElement.target = "_blank";

        // Create a more user-friendly link text (optional improvement)
        // linkElement.textContent = `Click here to view the content`;
        linkElement.textContent = iframeSrc;

        // Apply the truncation class to the link element
        linkElement.classList.add("truncated-link");
        // Replace iframe with the link while keeping it inside the parent tag (e.g., table, td)
        iframe.parentNode.replaceChild(linkElement, iframe);
      }
    });

    // Return the updated HTML as a string
    return tempDiv.innerHTML;
  };

  const [openCompletedStep, setOpenCompletedStep] = useState(null); // Track the open completed step

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div
        className="row"
        style={{ marginBottom: "3rem", gap: fromMeeting ? "4px" : "" }}
      >
        {meeting?.steps?.map((item, index) => {
          let editorContent = item.editor_content;
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = editorContent;
          const firstImageTag = tempDiv.querySelector("img");
          const firstImageUrl = firstImageTag
            ? firstImageTag.getAttribute("src")
            : "";

          return (
            <>
              <div className="col-12 email-step" key={index}>
                <Card
                  className="mt-4 step-card"
                  style={{
                    cursor:
                      item?.step_status === "in_progress" ||
                      item?.step_status === "completed"
                        ? "pointer"
                        : "",
                  }}
                  onClick={() => {
                    if (item?.step_status === "completed") {
                      setOpenCompletedStep((prev) =>
                        prev === index ? null : index
                      );
                    }
                  }}
                >
                  <Card.Body className="d-flex">
                    <div className="d-flex align-items-center">
                      <div className="step-number-container">
                        <span className="step-number">
                          {item?.order_no <= 9 ? "0" : " "}
                          {item?.order_no}
                        </span>
                      </div>
                      {/* <span className="step-number">{index + 1}.</span> */}
                      <div
                        className={` ${
                          (dropdownVisible[index] &&
                            item?.step_status === "in_progress") ||
                          openCompletedStep === index
                            ? "d-none"
                            : "d-block"
                        }`}
                      >
                        {(item?.editor_type === "Editeur" ||
                          item?.editor_type === "Subtask") &&
                        item.editor_content &&
                        item.editor_content.trim() !==
                          "<html><head></head><body></body></html>" ? (
                          <div className="step-img-container">
                            {firstImageUrl ? (
                              <Card.Img
                                className="step-img report-step-img"
                                src={firstImageUrl}
                              />
                            ) : (
                              <div className="fallback-img-container">
                                <FiEdit
                                  className="file-img img-fluid"
                                  style={{ padding: "40px" }}
                                />
                              </div>
                            )}
                          </div>
                        ) : item.editor_type === "File" ? (
                          <div className="file-img-container">
                            <PiFilePdfLight
                              className="file-img img-fluid"
                              style={{ padding: "40px" }}
                            />
                          </div>
                        ) : item.editor_type === "Excel" ? (
                          <div className="file-img-container">
                            <RiFileExcel2Line
                              className="file-img img-fluid"
                              style={{ padding: "42px" }}
                            />
                          </div>
                        ) : item.editor_type === "Video" ? (
                          <div className="file-img-container">
                            <IoVideocamOutline
                              className="file-img img-fluid"
                              style={{ padding: "40px" }}
                            />
                          </div>
                        ) : item.editor_type === "Photo" ? (
                          <div className="file-img-container">
                            {/* <MdOutlinePhotoSizeSelectActual
                              className="file-img img-fluid"
                              style={{ padding: "40px" }}
                            /> */}
                            <Card.Img
                              className="step-img report-step-img"
                              src={Assets_URL + "/" + item?.file}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          </div>
                        ) : item.url ? (
                          <div className="link-img-container">
                            <IoCopyOutline
                              className="file-img img-fluid"
                              style={{ padding: "40px" }}
                            />
                          </div>
                        ) : (
                          <div className="fallback-img-container">
                            <FiEdit
                              className="file-img img-fluid"
                              style={{ padding: "40px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className="ms-3 d-flex justify-content-center flex-column step-data w-100"
                      style={{ overflow: "auto" }}
                    >
                      <div className="step-header justify-content-between">
                        <div className="d-flex">
                          <Card.Title className="step-card-heading">
                            {item?.title}
                          </Card.Title>
                          <>
                            {item.step_status === "completed" ? (
                              <span className="status-badge-completed">
                                {/* Completed */}
                                {t("badge.completed")}
                              </span>
                            ) : item.step_status === "in_progress" ? (
                              <span
                                className={
                                  convertTimeTakenToSeconds(item?.time_taken) >
                                  convertCount2ToSeconds(
                                    item?.count2,
                                    item?.time_unit
                                  )
                                    ? "status-badge-red"
                                    : "status-badge-inprogress"
                                }
                              >
                                {t("badge.inprogress")}
                              </span>
                            ) : item.step_status === "to_finish" ? (
                              <span className={"status-badge-finish"}>
                                {t("badge.finish")}
                              </span>
                            ) : item?.step_status === "cancelled" ? (
                              <span className={"status-badge-cancel"}>
                                {t("badge.cancel")}
                              </span>
                            ) : item?.step_status === "todo" ? (
                              // null
                              <span className="status-badge-green">
                                {t("badge.todo")}
                              </span>
                            ) : item.step_status === "paused" ? (
                              <span className={"status-badge-red"}>
                                {t("badge.paused")}
                              </span>
                            ) : (
                              // null
                              <span className="status-badge-upcoming">
                                {t("badge.future")}
                                {/* Upcoming */}
                              </span>
                            )}
                          </>
                        </div>

                        {item?.step_status === "in_progress" && (
                          <MdKeyboardArrowDown
                            style={{ cursor: "pointer" }}
                            size={26}
                          />
                        )}

                        {item?.step_status === "completed" && (
                          <>
                            {openCompletedStep === index ? (
                              <MdKeyboardArrowUp
                                style={{ cursor: "pointer" }}
                                size={26}
                                // // onClick={() => setOpenCompletedStep(null)} // Close the open step when the up arrow is clicked
                                // onClick={() => {
                                //   if (item?.step_status === "completed") {
                                //     setOpenCompletedStep((prev) =>
                                //       prev === index ? null : index
                                //     );
                                //   }
                                // }}
                              />
                            ) : (
                              <MdKeyboardArrowDown
                                style={{ cursor: "pointer" }}
                                size={26}
                                // onClick={() => setOpenCompletedStep(index)} // Set this step as open when the down arrow is clicked
                                // onClick={() => {
                                //   if (item?.step_status === "completed") {
                                //     setOpenCompletedStep((prev) =>
                                //       prev === index ? null : index
                                //     );
                                //   }
                                // }}
                              />
                            )}
                          </>
                        )}
                      </div>

                      <Card.Subtitle className="step-card-subtext">
                        {meeting.newsletter_guide ? (
                          <>
                            {meeting?.newsletter_guide?.logo ? (
                              <img
                                height="24px"
                                width="24px"
                                style={{
                                  marginRight: "9px",
                                  borderRadius: "20px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                                src={
                                  meeting?.newsletter_guide?.logo?.startsWith("http") ? meeting?.newsletter_guide?.logo:
                                  Assets_URL + "/" + meeting?.newsletter_guide?.logo
                                }
                                alt={meeting?.newsletter_guide?.name}
                              />
                            ) : (
                              <HiUserCircle
                                style={{
                                  height: "24px",
                                  width: "24px",
                                }}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {item?.assigned_to_image ? (
                              <img
                                height="24px"
                                width="24px"
                                style={{
                                  marginRight: "9px",
                                  borderRadius: "20px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                                src={
                                  item?.assigned_to_image?.startsWith("users/")
                                    ? Assets_URL + "/" + item?.assigned_to_image
                                    : // : item?.image?.startsWith("users/")
                                      // ? Assets_URL + "/" + item.image
                                      item?.assigned_to_image
                                }
                                // src={
                                //     item?.assigned_to_image
                                // }
                                alt="img"
                              />
                            ) : (
                              <img
                                height="24px"
                                width="24px"
                                style={{
                                  marginRight: "9px",
                                  borderRadius: "20px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                                src={
                                  users?.assigned_to_image?.startsWith("users/")
                                    ? Assets_URL +
                                      "/" +
                                      users?.assigned_to_image
                                    : users?.assigned_to_image
                                }
                                alt="img"
                              />
                            )}
                          </>
                        )}

                        {meeting?.newsletter_guide ? (
                          <span>{meeting?.newsletter_guide?.name}</span>
                        ) : (
                          <span>
                            {item?.assigned_to_name ||
                              `${users?.firstName} ${users?.lastName}`}
                          </span>
                        )}
                      </Card.Subtitle>
                      <Card.Text className="step-card-content">
                        <img
                          height="16px"
                          width="16px"
                          style={{
                            width: "auto",
                            marginRight: "9px",
                          }}
                          src="/Assets/ion_time-outline.svg"
                        />
                        {item?.time_unit === "days" ? (
                          <>
                            {item.step_status === null ||
                            item?.step_status === "todo"
                              ? formatStepDate(
                                  item.start_date,
                                  item?.step_time,
                                  meeting?.timezone
                                )
                              : formatStepDate(
                                  item.start_date,
                                  item?.step_time,
                                  meeting?.timezone
                                )}
                          </>
                        ) : (
                          <>
                            {item?.step_status === null ||
                            item?.step_status === "todo"
                              ? formatStepDate(
                                  item.start_date,
                                  item?.step_time,
                                  meeting?.timezone
                                ) +
                                " " +
                                ` ${t("at")}` +
                                " " +
                                // item?.step_time
                                convertTo24HourFormat(
                                  item?.step_time,
                                  item?.start_date,
                                  item?.time_unit,
                                  meeting?.timezone
                                )
                              : formatStepDate(
                                  item.start_date,
                                  item?.step_time,
                                  meeting?.timezone
                                ) +
                                " " +
                                ` ${t("at")}` +
                                " " +
                                // item?.step_time
                                convertTo24HourFormat(
                                  item?.step_time,
                                  item?.start_date,
                                  item?.time_unit,
                                  meeting?.timezone
                                )}
                          </>
                        )}
                      </Card.Text>
                      <Card.Text className="step-card-content">
                        <img
                          height="16px"
                          width="16px"
                          style={{
                            width: "auto",
                            marginRight: "9px",
                            // marginLeft: "1rem",
                          }}
                          src="/Assets/alarm-invite.svg"
                        />
                        {item?.step_status === null ||
                        item?.step_status === "todo"
                          ? item.count2 + " " +                                                 `${  getTimeUnitDisplay(item?.count2, item?.time_unit, t)}`
                          
                          : item?.step_status === "to_finish" ? formatPauseTime(
                              item?.work_time,t
                            ) : localizeTimeTakenActive(
                              item?.time_taken?.replace("-", "")
                            )}
                      </Card.Text>

                      {item?.step_status === "in_progress" ? (
                        <>
                          {item?.editor_content &&
                          (item?.editor_type === "Editeur" ||
                            item?.editor_type === "Email" ||
                            item?.editor_type === "Subtask") &&
                          item?.editor_content?.trim() !==
                            "<html><head></head><body></body></html>" ? (
                            <div
                              style={{
                                width: "100%", // Full width of the parent container
                                maxWidth: "100%",
                                height: item?.editor_content?.includes("<img")
                                  ? "auto"
                                  : "auto", // Conditional height
                                overflowY: item?.editor_content?.includes(
                                  "<img"
                                )
                                  ? "auto"
                                  : "visible", // Only scroll if images are present
                                overflowX: "hidden",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "start",
                                justifyContent: "center",
                              }}
                              className="customize-scroller"
                            >
                              <div className="scrollableContainer rendered-content-step-report">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: sanitizeContent(
                                      item?.editor_content
                                    ),
                                  }}
                                />
                              </div>
                            </div>
                          ) : item.url ? (
                            <div
                              style={{
                                borderRadius: "10px",
                              }}
                            >
                              <iframe
                                src={getYoutubeEmbedUrl(item?.url)}
                                width="100%"
                                height="630px"
                              />
                            </div>
                          ) : item?.editor_type === "Excel" ? (
                            <div
                              style={{
                                borderRadius: "10px",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  height: "630px",
                                  overflowY: "auto",
                                  textAlign: "center",
                                }}
                              >
                                {excelData && (
                                  <Spreadsheet data={excelData || null} />
                                )}
                              </div>
                            </div>
                          ) : item?.file && item?.editor_type === "File" ? (
                            <div
                              style={{
                                borderRadius: "10px",
                              }}
                            >
                              <iframe
                                src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                width="100%"
                                height="630px"
                              />
                            </div>
                          ) : item?.file && item?.editor_type === "Url" ? (
                            <iframe
                              src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                              width="100%"
                              height="630px"
                            />
                          ) : item?.file &&
                            item?.editor_type === "Video Report" ? (
                            <iframe
                              src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                              width="100%"
                              height="630px"
                            />
                          ) : item?.file &&
                            item?.editor_type === "Audio Report" ? (
                            <iframe
                              src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                              width="100%"
                              height="630px"
                            />
                          ) : item?.file && item?.editor_type === "Video" ? (
                            <iframe
                              src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                              width="100%"
                              height="630px"
                            />
                          ) : item?.file && item?.editor_type === "Photo" ? (
                            <iframe
                              src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                              width="100%"
                              height="630px"
                            />
                          ) : null}
                        </>
                      ) : null}
                      {item?.step_status === "completed" &&
                        openCompletedStep === index && (
                          <div style={{ height: "auto" }}>
                            {item?.editor_content &&
                            (item?.editor_type === "Editeur" ||
                              item?.editor_type === "Email" ||
                              item?.editor_type === "Subtask") &&
                            item?.editor_content?.trim() !==
                              "<html><head></head><body></body></html>" ? (
                              <div
                                style={{
                                  width: "100%", // Full width of the parent container
                                  maxWidth: "100%",
                                  height: item?.editor_content?.includes("<img")
                                    ? "auto"
                                    : "auto", // Conditional height
                                  overflowY: item?.editor_content?.includes(
                                    "<img"
                                  )
                                    ? "auto"
                                    : "visible", // Only scroll if images are present
                                  overflowX: "hidden",
                                  borderRadius: "10px",
                                  display: "flex",
                                  alignItems: "start",
                                  justifyContent: "center",
                                }}
                                className="customize-scroller"
                              >
                                <div className="scrollableContainer rendered-content-step-report">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: sanitizeContent(
                                        item?.editor_content
                                      ),
                                    }}
                                  />
                                </div>
                              </div>
                            ) : item.url ? (
                              <div
                                style={{
                                  borderRadius: "10px",
                                }}
                              >
                                <iframe
                                  src={getYoutubeEmbedUrl(item?.url)}
                                  width="100%"
                                  height="630px"
                                />
                              </div>
                            ) : item?.editor_type === "Excel" ? (
                              <div
                                style={{
                                  borderRadius: "10px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    height: "630px",
                                    overflowY: "auto",
                                    textAlign: "center",
                                  }}
                                >
                                  {excelData && (
                                    <Spreadsheet data={excelData || null} />
                                  )}
                                </div>
                              </div>
                            ) : item?.file && item?.editor_type === "File" ? (
                              <div
                                style={{
                                  borderRadius: "10px",
                                }}
                              >
                                <iframe
                                  src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                  width="100%"
                                  height="630px"
                                />
                              </div>
                            ) : item?.file && item?.editor_type === "Url" ? (
                              <iframe
                                src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                width="100%"
                                height="630px"
                              />
                            ) : item?.file &&
                              item?.editor_type === "Video Report" ? (
                              <iframe
                                src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                width="100%"
                                height="630px"
                              />
                            ) : item?.file &&
                              item?.editor_type === "Audio Report" ? (
                              <iframe
                                src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                width="100%"
                                height="630px"
                              />
                            ) : item?.file && item?.editor_type === "Video" ? (
                              <iframe
                                src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                width="100%"
                                height="630px"
                              />
                            ) : item?.file && item?.editor_type === "Photo" ? (
                              <iframe
                                src={`${Assets_URL}/${item.file}#toolbar=0&view=fitH`}
                                width="100%"
                                height="630px"
                              />
                            ) : null}
                          </div>
                        )}
                    </div>
                  </Card.Body>
                  {(item?.step_status === null ||
                    item?.step_status === "to_finish") &&
                  meeting?.guides?.some(
                    (guide) => guide?.email === sessionStorage.getItem("email")
                  ) ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "-20px",
                        marginRight: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: "#0026b1",
                          color: "#fff",
                          border: "none",
                          padding: "10px 20px",
                          fontSize: "16px",
                          cursor: "pointer",
                          borderRadius: "5px",
                          transition: "background-color 0.3s",
                          display: "flex",
                          alignItems: "center",
                          opacity: isRun || isReOpen ? 0.4 : 1
                        }}
                        onClick={() => {
                          if (item?.step_status === null) {
                            runStep(item);
                          } else if (item?.step_status === "to_finish") {
                            reRunStep(item);
                          }
                        }}
                        disabled={isRun || isReOpen}
                      >
                        {item?.step_status === null
                          ? t("startMoment")
                          : t("ReOpen")}
                      </button>
                    </div>
                  ) : null}
                </Card>
              </div>
            </>
          );
        })}
      </div>
    </Suspense>
  );
};

export default ActiveReportStepCard;
